// ─── Risk dots (design-system severity indicator) ──────────────────────────
// Three-dot meter: low = 1 dot (scrubs green), moderate = 2 (orange),
// high = 3 (fuschia/plum). Extracted from PatientSidebar so the same
// indicator can be reused anywhere severity needs to read at a glance
// (sidebar risk history, pre-visit claims insight rows, …).

// Re-exported, not redeclared: the level vocabulary belongs to the domain
// model, and having two same-named types meant `RiskLevel` resolved to
// something different depending on which path you imported it from.
import type { RiskLevel } from '../../models/user'

export type { RiskLevel }

const RISK_FILL: Record<RiskLevel, string> = {
  low:      'var(--scrubs)',
  moderate: 'var(--orange)',
  high:     'var(--fuschia)',
}
const RISK_FILLED_COUNT: Record<RiskLevel, number> = { low: 1, moderate: 2, high: 3 }
const RISK_LABEL: Record<RiskLevel, string> = { low: 'Low Risk', moderate: 'Moderate Risk', high: 'High Risk' }

interface Props {
  level: RiskLevel
  /** Show the "Low/Moderate/High Risk" text label next to the dots
   *  (sidebar style). Omit for the dots-only form (insight rows). */
  showLabel?: boolean
}

export function RiskDots({ level, showLabel = true }: Props) {
  const filled = RISK_FILLED_COUNT[level]
  const fill = RISK_FILL[level]
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={RISK_LABEL[level]}>
      {showLabel && (
        <span style={{
          fontSize: 'var(--text-xs-b-size)', fontWeight: 'var(--text-xs-b-weight)', lineHeight: 'var(--text-xs-b-lh)', letterSpacing: '0.01em',
          color: 'var(--seafoam)', fontFamily: 'var(--font-body)',
        }}>
          {RISK_LABEL[level]}
        </span>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        {[1, 2, 3].map(i => (
          <span key={i} style={{
            width: 8, height: 8, borderRadius: 2,
            background: i <= filled ? fill : 'transparent',
            border: i <= filled ? 'none' : '1px solid var(--steel)',
          }} />
        ))}
      </div>
    </div>
  )
}
